$(document).ready(function () {
  // Enable This for Play Button Functionaly
  $('#player-v1').on('click', function () {
    $(this).hide();
    $('#about-v1-video').attr({ controls: '', autoplay: '', playsinline: '' });
    $('#about-v1-video').get(0).play();
  });

  // Map Link Here
  // https://www.embedmymap.com

  let allMaps = $(document).find('#map1, #map2, #map3');
  function mapsHide() {
    allMaps.each(function () {
      $(this).hide();
    });
  }

  // Map 1
  $('#accordionOne').on('show.bs.collapse', function () {
    mapsHide();
    $('#map1').show();
  });

  // Map 2
  $('#accordionTwo').on('show.bs.collapse', function () {
    mapsHide();
    $('#map2').show();
  });

  // Map 3
  $('#accordionThree').on('show.bs.collapse', function () {
    mapsHide();
    $('#map3').show();
  });

  /* always keep at least 1 open by preventing the current to close itself */
  const accordions = document.querySelectorAll('.accordion-collapse');
  let opening = false;
  accordions.forEach(function (el) {
    el.addEventListener('hide.bs.collapse', (event) => {
      if (!opening) {
        event.preventDefault();
        event.stopPropagation();
      } else {
        opening = false;
      }
    });
    el.addEventListener('show.bs.collapse', (event) => {
      opening = true;
    });
  });
});
